import { render, staticRenderFns } from "./RecruiteeOfferSelect.vue?vue&type=template&id=28b5b9f7"
import script from "./RecruiteeOfferSelect.vue?vue&type=script&lang=ts"
export * from "./RecruiteeOfferSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports